<script setup>
  const app = computed(() => usePage().props.app);
</script>
<template>
  <img src="/uploads/site/logo.png" />
</template>
